import React from "react";
import { ArrowDownIcon } from "@heroicons/react/outline";
import { ArrowUpIcon } from "@heroicons/react/solid";
import {
  IconArrowBarToDown,
  IconArrowBarToUp,
  IconPencil,
  IconTrash,
} from "@tabler/icons-react";
import clsx from "clsx";

const RuleActions = (props: {
  onEdit: () => void;
  className?: string;
  onRemoveClicked?: () => void | undefined;
  moveUp?: () => void;
  moveDown?: () => void;
  moveToTop?: () => void;
  moveToBottom?: () => void;
}) => {
  const itemClassNames = "mr-2 cursor-pointer hover:text-indigo-800";

  return (
    <div
      className={clsx(
        props.className,
        "items-center absolute right-2 top-1/2 transform -translate-y-1/2 text-indigo-700",
        "hidden group-hover/ruleRow:flex h-[95%]"
      )}
    >
      <div
        className={clsx(
          "pl-5 pr-3 bg-gradient-to-r from-transparent from-0 to-50% to-indigo-50",
          "flex justify-center items-center h-[95%]"
        )}
      ></div>
      <div
        className="bg-indigo-50 h-full flex items-center justify-center pr-2 text-indigo-700"
        onClick={(e) => e.stopPropagation()}
      >
        <ArrowUpIcon
          width={16}
          strokeWidth="2.5"
          className={clsx(itemClassNames, {
            "!cursor-not-allowed opacity-50": props.moveUp === undefined,
          })}
          onClick={props.moveUp}
        />
        <ArrowDownIcon
          width={16}
          strokeWidth="2.5"
          className={clsx(itemClassNames, {
            "!cursor-not-allowed opacity-50": props.moveDown === undefined,
          })}
          onClick={props.moveDown}
        />
        <IconArrowBarToUp
          size={16}
          stroke="2.5"
          className={clsx(itemClassNames, {
            "!cursor-not-allowed opacity-50": props.moveToTop === undefined,
          })}
          onClick={props.moveToTop}
        />
        <IconArrowBarToDown
          size={16}
          stroke="2.5"
          className={clsx(itemClassNames, {
            "!cursor-not-allowed opacity-50": props.moveToBottom === undefined,
          })}
          onClick={props.moveToBottom}
        />
        <IconPencil
          size={16}
          stroke="2.5"
          className={itemClassNames}
          onClick={props.onEdit}
        />
        {props.onRemoveClicked && (
          <IconTrash
            size={16}
            stroke="2.5"
            className={itemClassNames}
            onClick={props.onRemoveClicked}
          />
        )}
      </div>
    </div>
  );
};

export default RuleActions;
